import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { ConfirmProvider } from './components/ConfirmDialog';
import { queryClient as browserQueryClient } from './lib/queryClient';
/**
 * The providers around every page. The browser (main.tsx) and the prerender
 * (entry-server.tsx) both render through this, so a prerendered page's markup is exactly
 * what the browser hydrates.
 */ export function AppProviders({ children, queryClient = browserQueryClient, helmetContext }) {
    return /*#__PURE__*/ _jsx(QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/ _jsx(HelmetProvider, {
            context: helmetContext,
            children: /*#__PURE__*/ _jsx(ConfirmProvider, {
                children: children
            })
        })
    });
}
